import { css } from '@emotion/react';

export const LAYOUT_OPTIONS = {
  ONE: {
    key: 'ONE',
    label: '1 Panel',
    styles: css`
      //No op
    `,
    cardCount: 1,
  },
  TWO: {
    key: 'TWO',
    label: '2 Panels',
    styles: css`
      grid-template-columns: 1fr 1fr;
    `,
    cardCount: 2,
  },
  TWO_VERTICAL: {
    key: 'TWO_VERTICAL',
    label: '2 Panels (Vertical)',
    styles: css`
      grid-template-columns: 1fr;
      grid-template-rows: 1fr 1fr;
    `,
    cardCount: 2,
  },
  THREE: {
    key: 'THREE',
    label: '3 Panels',
    styles: css`
      grid-template-columns: 1fr 1fr;
      grid-template-rows: 1fr .75fr;
      & *:nth-of-type(3) {
        grid-column: 1 / span 2;
      }
    `,
    cardCount: 3,
  },
  FOUR: {
    key: 'FOUR',
    label: '4 Panels',
    styles: css`
      grid-template-columns: 1fr 1fr;
      grid-template-rows: 1fr 1fr;
    `,
    cardCount: 4,
  },
  SIX: {
    key: 'SIX',
    label: '6 Panels',
    styles: css`
      grid-template-columns: 1fr 1fr 1fr;
      grid-template-rows: 1fr 1fr;
    `,
    cardCount: 6,
  },
};

